import { parse as parseCsvString } from 'csv-string';

/**
 * This method processes a CSV string into data organized by column to be
 * consumed by the specs section table component. See the tests for examples.
 */
export const processTableData = (tableData = '') => {
  if (tableData === '' || tableData === null) return [];

  const rows = parseCsvString(tableData);

  return rows.reduce((result, row, i) => {
    // if this is the header, set up the initial column data
    if (i === 0) {
      return row.map(header => ({
        data: [],
        header: header.replace(/\s{2,}/gim, '\n')
      }));
    }
    // iterate over the columns and pull out the corresponding column value from
    // the current row
    return result.map((column, j) => ({
      ...column,
      data: [...column.data, row[j]]
    }));
  }, []);
};
